import ParkCloud from './park-cloud';
import { translator } from './_util';

//const host = 'https://supplyinfo.net/park-cloud';
//const host = 'http://localhost:3000';
const host = 'https://parkinginfo.dodohome.com.tw';

const parkCloud = new ParkCloud(host, '1-8fdc8cd6677041ea92e033afee286726');

export { parkCloud, translator };